// StatusBadge — small colored status pill

type BadgeVariant = "green" | "yellow" | "red" | "blue" | "muted";

interface StatusBadgeProps {
  label: string;
  variant: BadgeVariant;
}

const VARIANT_CLASSES: Record<BadgeVariant, string> = {
  green:
    "bg-green-500/15 text-green-700 dark:text-green-400 border border-green-500/30",
  yellow:
    "bg-amber-500/15 text-amber-700 dark:text-amber-400 border border-amber-500/30",
  red: "bg-red-500/15 text-red-700 dark:text-red-400 border border-red-500/30",
  blue: "bg-blue-500/15 text-blue-700 dark:text-blue-400 border border-blue-500/30",
  muted:
    "bg-zinc-500/15 text-zinc-600 dark:text-zinc-400 border border-zinc-500/30",
};

const DOT_CLASSES: Record<BadgeVariant, string> = {
  green: "bg-green-500",
  yellow: "bg-amber-500",
  red: "bg-red-500",
  blue: "bg-blue-500",
  muted: "bg-zinc-400",
};

export default function StatusBadge({ label, variant }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium ${VARIANT_CLASSES[variant]}`}
    >
      <span
        className={`w-1.5 h-1.5 rounded-full shrink-0 ${DOT_CLASSES[variant]}`}
      />
      {label}
    </span>
  );
}
